import type { ComponentProps, ComponentType } from 'react';
import styled from 'styled-components';

import { CenterContentContainer, getContrastingTextColor, hexWithAlpha, mediaOnly, mediaUpTo } from '@p2l/ui-public';

export const SiteFooter: ComponentType<ComponentProps<'footer'>> = styled.footer`
  background-color: ${({ theme }) => theme.components.footer.backgroundColor};

  --p2l-container-max-width: calc(1400px - var(--p2l-current-scrollbar-width, 0px));
  --p2l-container-side-padding: 48px;

  @media (max-width: 959px) and (min-width: 601px) {
    --p2l-container-side-padding: 24px;
  }

  @media (max-width: 600px) {
    --p2l-container-side-padding: 16px;
  }
`;

export const CustomFooterWrapper: ComponentType<ComponentProps<'div'>> = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.components.separator.inverted};
  padding: 24px 0;
  color: ${({ theme }) => getContrastingTextColor(theme.components.footer.backgroundColor)};
`;

export const CustomFooter: ComponentType<ComponentProps<'div'>> = styled.div`
  color: ${({ theme }) => getContrastingTextColor(theme.components.footer.backgroundColor)};
  width: 100%;

  ${mediaUpTo('desktop')} {
    text-align: center;
  }

  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const StyledCenterContentContainer = styled(CenterContentContainer)`
  ${mediaOnly('mobile')} {
    padding: 0;
  }
`;

export const FooterRightContentWrapper: ComponentType<ComponentProps<'div'>> = styled.div`
  display: flex;
  justify-content: end;
  padding: 16px 0;

  ${mediaOnly('mobile')} {
    flex-direction: column;
  }
`;

export const StyledFooterButton: ComponentType<ComponentProps<'div'>> = styled.div`
  margin-right: 8px;
  text-decoration: none;
  font-size: 14px;
  color: ${({ theme }) => (getContrastingTextColor(theme.components.footer.backgroundColor))};
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 5px;

  &:hover {
    background-color: ${({ theme }) =>
      hexWithAlpha(getContrastingTextColor(theme.components.footer.backgroundColor), 10)};
  }

  ${mediaOnly('mobile')} {
    text-align: center;
    margin: 8px 16px 0;

    &:first-child {
      margin: 0 16px 0;
    }
  }
`;

export const LanguagePickerWrapper: ComponentType<ComponentProps<'div'>> = styled.div`
  ${mediaOnly('mobile')} {
    display: flex;
    justify-content: flex-end;
    margin: 16px 0 0;
    padding: 16px 16px 0;
    border-top: 1px solid ${({ theme }) => theme.components.separator.inverted};

    > * {
      width: auto;
    }
  }
`;